import { render } from "./RoundCard.vue?vue&type=template&id=e59c0084&scoped=true"
import script from "./RoundCard.vue?vue&type=script&lang=js"
export * from "./RoundCard.vue?vue&type=script&lang=js"

import "./RoundCard.vue?vue&type=style&index=0&id=e59c0084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59c0084"]])

export default __exports__